import { useQueryClient } from "@tanstack/react-query";
import { GraphQLClient } from "graphql-request";

import { Day, HoursOff } from "../../generated-types";
import {
  GetDaysByUserQuery,
  GetDaysByUserQueryVariables,
  useGetDaysByUserQuery
} from "./../../queries/days/index.generated";
import {
  useCreateHoursOffMutation,
  useDeleteHoursOffMutation,
  useUpdateHoursOffMutation
} from "./index.generated";

export const useCreateHoursOff = ({
  day,
  setCurrentDay,
  client,
  variables
}: {
  day?: Day;
  setCurrentDay?: React.Dispatch<React.SetStateAction<Day | undefined | null>>;
  client: GraphQLClient;
  variables: GetDaysByUserQueryVariables;
}) => {
  const queryClient = useQueryClient();
  const { mutateAsync: createHoursOffMutation, ...options } =
    useCreateHoursOffMutation(client, {
      onSuccess: (data) => {
        const daysData: GetDaysByUserQuery | null | undefined =
          queryClient.getQueryData(useGetDaysByUserQuery.getKey(variables));

        // console.log("daysData ", daysData);

        const newHoursOff = data?.createHoursOff as HoursOff;

        const newDay: Day = {
          ...(day as Day),
          hoursOff: [...((day as Day).hoursOff ?? []), newHoursOff]
        };

        // se esiste
        if (setCurrentDay) {
          setCurrentDay(newDay);
        }

        const newData = daysData?.days?.map((_day) => {
          if (day?.documentId === _day?.documentId) {
            return newDay;
          }
          return _day;
        });

        const _data = {
          days: newData
        };

        if (daysData) {
          queryClient.setQueryData(
            useGetDaysByUserQuery.getKey(variables),
            (_old: any) => _data
          );
        }
      }
    });

  return { createHoursOffMutation, options };
};

export const useDeleteHoursOff = ({
  day,
  setCurrentDay,
  client,
  variables
}: {
  day?: Day;
  setCurrentDay?: React.Dispatch<React.SetStateAction<Day | undefined | null>>;
  client: GraphQLClient;
  variables: GetDaysByUserQueryVariables;
}) => {
  const queryClient = useQueryClient();

  const { mutateAsync: deleteHoursOffMutation, ...options } =
    useDeleteHoursOffMutation(client, {
      onSuccess: (data) => {
        const daysData: GetDaysByUserQuery | null | undefined =
          queryClient.getQueryData(useGetDaysByUserQuery.getKey(variables));

        const newHoursOff =
          day?.hoursOff?.filter(
            (hoursOff) =>
              hoursOff?.documentId !== data?.deleteHoursOff?.documentId
          ) ?? [];

        const newDay: Day = {
          ...(day as Day),
          hoursOff: newHoursOff
        };

        // eliminare dalla cache
        const newData = daysData?.days?.map((_day) => {
          if (day?.documentId === _day?.documentId) {
            return newDay;
          }
          return _day;
        });

        // se esiste
        if (setCurrentDay) {
          setCurrentDay(newDay);
        }

        const _data = {
          days: newData
        };

        if (daysData) {
          queryClient.setQueryData(
            useGetDaysByUserQuery.getKey(variables),
            (_old) => _data
          );
        }
      }
    });

  return { deleteHoursOffMutation, options };
};

export const useUpdateHoursOff = ({
  day,
  setCurrentDay,
  client,
  variables
}: {
  day?: Day;
  setCurrentDay?: React.Dispatch<React.SetStateAction<Day | undefined | null>>;
  client: GraphQLClient;
  variables: GetDaysByUserQueryVariables;
}) => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateHoursOffMutation, ...options } =
    useUpdateHoursOffMutation(client, {
      onSuccess: (data) => {
        const daysData: GetDaysByUserQuery | null | undefined =
          queryClient.getQueryData(useGetDaysByUserQuery.getKey(variables));

        //  aggiorno la cache
        const newHoursOff =
          day?.hoursOff?.map((hoursOff) => {
            if (hoursOff?.documentId === data?.updateHoursOff?.documentId) {
              return data?.updateHoursOff as HoursOff;
            }
            return hoursOff as HoursOff;
          }) ?? [];

        const newDay: Day = {
          ...(day as Day),
          hoursOff: newHoursOff
        };

        // se esiste
        if (setCurrentDay) {
          setCurrentDay(newDay);
        }

        const newData = daysData?.days?.map((_day) => {
          if (day?.documentId === _day?.documentId) {
            return newDay;
          }
          return _day;
        });

        const _data = {
          days: newData
        };

        if (daysData) {
          queryClient.setQueryData(
            useGetDaysByUserQuery.getKey(variables),
            (_old) => _data
          );
        }
      }
    });

  return { updateHoursOffMutation, options };
};
